import { cloneElement, isValidElement } from 'react'
import { ButtonBaseProps } from '../ButtonBase'
import { Container } from './styles'

interface IconButtonProps extends ButtonBaseProps {
  children: React.ReactNode
}
export const IconButton = ({ children, ...rest }: IconButtonProps) => {
  if (!children || !isValidElement(children)) {
    return <Container {...rest}>{children}</Container>
  }

  const clonedChildren = cloneElement(children as React.ReactElement, {
    // @ts-expect-error cloning a custom component
    size: 'button',
  })

  return <Container {...rest}>{clonedChildren}</Container>
}
